import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { Order } from '../../models/order';
import { QuotesConfigService } from '../../services/quotes-config/quotes-config.service';

@Component({
    selector: 'lib-quotes',
    template: '<lib-filter-list [configService]="config"></lib-filter-list>',
    styleUrls: ['./quotes.component.css'],
    standalone: false
})
export class QuotesComponent extends ListItemRendererComponent<Order[]> implements OnInit, AfterViewInit {
  public config = inject(QuotesConfigService);

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }
}
